<div *ngIf="!getError" #reportContainer class="power-bi"></div>
<div *ngIf="getError"><span class="pi pi-exclamation-triangle"></span>{{'PowerBI.Widget.GetError' | transloco}}</div>